/*
  AP-PICK-SET — client logic for sections/ap-pick-set.liquid (layout C: the Afroyla picker pattern).
  State: pack (1 / 2 / 4), the set size, N slots = null | { idx, size override }, the active line tab and which tabs
  are expanded past the first page. Every product carries its Milk Silk variants only ([id, size, price, available]);
  the pack price is shown here and the real variant price is discounted in the cart by the Shopify Function that reads
  the `_pick` line property.
  Grid: ADD TO MY SET fills the first empty slot (set size unless the slot is overridden in its sheet); the slot row
  shows the picks with the YOU PAY / +$30 tags; tapping a filled box opens the sheet (size for that dress, or Remove).
  Details sheet (owner 12/10 18:55): "View details" opens an in-page sheet (never navigates): photos + first paragraph
  from /products/<handle>.js fetched on open (cached per dress), the Milk Silk size row (tap = the size this dress is
  added in), the size-chart link, ADD TO MY SET (= the card button, then closes), "Open product page" at the bottom.
  Lines: corset / sweetheart / vneck / longsleeve (the Long Sleeve Maxi, Milk Silk $79.99).
  Cart add = window.fetch to /cart/add.js with N lines (each with the `_pick` / `_pick_n` properties), then a no-op
  updateCart so the drawer repaints, then openCart; fallback = the Kaching-safe fetch from a blank iframe + the cart
  page. It must stay on the page's own fetch: that is the only route Shopify instruments, so it is what makes
  GA4 add_to_cart / Meta AddToCart / Elevar fire for a pick (fixed 29/10/2026 — see addLines).
  One-line clones (owner 14/10): data.fabrics (fabric picker: prices, slot tags, summary, button, sticky, hero / heading /
  sub / pack-sub data-tpl texts, size availability and the variants added all follow the picked fabric; ?fabric=cotton)
  and data.designs (design tabs filter the grid by the dresses' tags). Both absent on the 4-line page.
  Owner 15/10: photo review cards open their photo larger in [data-ps-lb] (only rendered when a review has a photo).
*/
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  var cleanWin = null;
  function cleanFetch(path, opts) {
    try {
      if (!cleanWin || !cleanWin.fetch) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        f.src = 'about:blank';
        document.documentElement.appendChild(f);
        cleanWin = f.contentWindow;
      }
      return cleanWin.fetch(location.origin + path, opts);
    } catch (e) {
      return window.fetch(path, opts);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function fill(t, map) {
    return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; });
  }

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL', '8XL'];
  function sizeRank(s) {
    var petite = /petite/i.test(s), base = String(s).replace(/petite\s*/i, '').trim().toUpperCase();
    var i = SIZE_ORDER.indexOf(base);
    return (petite ? 100 : 0) + (i < 0 ? 50 : i);
  }

  function init(root) {
    if (root.__apPs) return;
    root.__apPs = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-ap-ps-data]').textContent); } catch (e) { return; }
    var T = data.text || {};
    // Owner 14/10 (one-line clone): fabric picker. data.fabrics = [{key, name, unit, packs}] (0 = Milk Silk = the Offer
    // prices, 1 = Cotton) and each variant row carries its fabric index (5th cell). Without it: one fabric, data.unit /
    // data.packs, every row fabric 0. `fab` = the picked fabric (default 0, ?fabric=cotton picks by key).
    var FABS = data.fabrics && data.fabrics.length > 1 ? data.fabrics : null;
    var fab = 0;
    // Design tabs ("find your print"): data.designs = [{key, label, tags[]}], each dress carries its matching tags.
    var DESIGNS = {};
    (data.designs || []).forEach(function (d) { if (d && d.key) DESIGNS[d.key] = d.tags || []; });
    var products = [];
    // Owner 14/10: no Petite sizes on this page. The Liquid already leaves them out; this drops any that slip through.
    var isPetite = function (s) { return /petite/i.test(String(s || '')); };
    (data.products || []).forEach(function (pr) {
      if (!pr || !pr.v || !pr.v.length) return;
      pr.sizes = (pr.sizes || []).filter(function (s) { return !isPetite(s); });
      pr.v = pr.v.filter(function (a) { return !isPetite(a[1]); });
      if (!pr.v.length) return;
      pr.variants = pr.v.map(function (a) { return { id: a[0], s: a[1], p: a[2], a: !!a[3], f: +a[4] || 0 }; });
      delete pr.v;
      pr.images = pr.images || [];
      pr.tags = pr.tags || [];
      products.push(pr);
    });
    if (!products.length) return;
    var $ = function (sel) { return root.querySelector(sel); };
    var money = function (c) { return formatMoney(c, data.moneyFormat); };
    var cdn = data.cdn || '';
    // Owner 17/10: + midaxi / ssmaxi / tee (one-line pages). Every line the section emits must be listed here: the All
    // interleave below loops until it has placed every product.
    var LINES = ['corset', 'sweetheart', 'vneck', 'longsleeve', 'midaxi', 'ssmaxi', 'tee'];
    var lineName = function (k) { return (data.lines || {})[k] || k; };
    var byLine = {};
    LINES.forEach(function (k) { byLine[k] = products.filter(function (p) { return p.line === k; }); });
    // "All" = the four lines interleaved by rank (list order = sales order), so the first page shows every style
    var allList = [];
    for (var r = 0; allList.length < products.length; r++) LINES.forEach(function (k) { if (byLine[k][r]) allList.push(byLine[k][r]); });
    // Owner 15/10 16:06: data.tabCap = the most dresses any tab shows, All included (absent / 0 = no cap). A design tab
    // filters the WHOLE list first, then caps, so a dress past the cap in All still shows in its design tab.
    var CAP = Math.max(0, Math.floor(+data.tabCap || 0));
    var listOf = function (tab) {
      var tg = DESIGNS[tab], l;
      if (tg) l = allList.filter(function (p) { return p.tags.some(function (t) { return tg.indexOf(t) > -1; }); });
      else l = tab === 'all' ? allList : (byLine[tab] || []);
      return CAP ? l.slice(0, CAP) : l;
    };
    var PAGE = Math.max(4, +data.pageSize || 12);

    /* ---------- images ---------- */
    function full(u) { u = String(u); return /^https?:/.test(u) ? u : (/^\/\//.test(u) ? 'https:' + u : cdn + u); }
    function sized(url, w) {
      url = full(url);
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function img(p, i, w) { var u = p.images[i] || p.images[0]; return u ? sized(u, w) : ''; }
    function productUrl(p) { return (data.productsBase || '/products/') + p.handle; }

    /* ---------- sizes: the union of every dress's sizes (regular only, petite removed above) ---------- */
    var allSizes = [];
    products.forEach(function (p) { (p.sizes || []).forEach(function (s) { if (allSizes.indexOf(s) < 0) allSizes.push(s); }); });
    allSizes.sort(function (a, b) { return sizeRank(a) - sizeRank(b); });

    /* ---------- state ---------- */
    var sortPacks = function (a) { return (a || []).slice().sort(function (x, y) { return x.n - y.n; }); };
    var basePacks = sortPacks(data.packs);
    var fabPacks = FABS ? FABS.map(function (f) { return sortPacks(f.packs); }) : null;
    // the picked fabric's packs / sold-apart price (the Offer ones when there is no fabric picker)
    var packOf = function (n) { var ps = fabPacks ? fabPacks[fab] : basePacks; for (var i = 0; i < ps.length; i++) if (ps[i].n === n) return ps[i]; return ps[0]; };
    var unitCents = function () { return FABS ? +FABS[fab].unit : data.unit; };
    var qs = {};
    try { location.search.replace(/^\?/, '').split('&').forEach(function (kv) { var p = kv.split('='); if (p[0]) qs[decodeURIComponent(p[0])] = decodeURIComponent(p[1] || ''); }); } catch (e) { /* ignore */ }
    if (FABS && qs.fabric) {
      var qf = String(qs.fabric).toLowerCase();
      FABS.forEach(function (f, i) { var k = String(f.key || '').toLowerCase(); if (k === qf || k.split('-')[0] === qf) fab = i; });
    }
    var startPack = packOf(+qs.pack || +data.defaultPack || 2).n;
    var startSize = allSizes.indexOf(qs.size) > -1 ? qs.size : (allSizes.indexOf(data.defaultSize) > -1 ? data.defaultSize : allSizes[0]);
    var state = { pack: startPack, size: startSize, slots: [], tab: 'all', expanded: {} };
    function idxOf(handle) { for (var i = 0; i < products.length; i++) if (products[i].handle === handle) return i; return -1; }
    function fitSlots() {
      var n = state.pack;
      state.slots = state.slots.filter(Boolean).slice(0, n);
      while (state.slots.length < n) state.slots.push(null);
    }
    if (idxOf(qs.pick) > -1) state.slots.push({ idx: idxOf(qs.pick), size: null });
    fitSlots();
    // ?hero=<handle>[,<handle>...] (owner 14/10; several handles since 23/10): those dresses lead the grid, in the order
    // given — the first cards of All, of any tag tab (those filter allList, so they inherit the order) and of each one's
    // own line tab. One handle behaves exactly as before. Several exist because a static ad shows three to eight prints
    // at once: the dress that stopped the scroll has to be on screen on arrival, not hunted for in a grid of twenty-two.
    // Separate from ?pick, so the live ?pick ads keep today's grid. Unknown or repeated handles are ignored.
    var heroes = [];
    String(qs.hero || '').split(',').forEach(function (h) {
      var p = products[idxOf(h.trim())];
      if (p && heroes.indexOf(p) < 0) heroes.push(p);
    });
    // unshift back to front, so heroes[0] ends up first
    heroes.slice().reverse().forEach(function (hero) {
      [allList, byLine[hero.line]].forEach(function (l) { var j = l.indexOf(hero); if (j > 0) { l.splice(j, 1); l.unshift(hero); } });
    });

    var prodOf = function (slot) { return products[slot.idx]; };
    var sizeOf = function (slot) { return slot.size || state.size; };
    // the variant in the picked fabric (size availability follows the fabric; the cart gets that fabric's variants)
    function variantOf(p, size) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].s === size && p.variants[i].f === fab) return p.variants[i]; return null; }
    function slotVariant(slot) { return variantOf(prodOf(slot), sizeOf(slot)); }
    function slotReady(slot) { if (!slot) return false; var v = slotVariant(slot); return !!(v && v.a); }
    function pickedCount() { return state.slots.filter(Boolean).length; }
    function isFull() { return pickedCount() >= state.pack; }
    function countWord(n) { return n + ' ' + (n === 1 ? T.dress : T.dresses); }
    function countIn(idx) { return state.slots.filter(function (s) { return s && s.idx === idx; }).length; }
    /* Card photo opens the details sheet that already exists, and the add button becomes a
       stepper once a dress is in the set. Shipped straight on 27/10/2026 (measured: the photo
       was 57% of the card with no handler; 11.7% of pick-page sessions hit a dead click, 7x
       the PDP). Built as A/B pick-card-tap-1 arm b; shipped unconditionally instead because the
       `landing` group makes 2.75 orders/arm/day, so GP/visitor could never call it. */
    /* take the last copy of this dress back out of the set */
    function removeOne(idx) {
      for (var i = state.slots.length - 1; i >= 0; i--) {
        if (state.slots[i] && state.slots[i].idx === idx) { state.slots[i] = null; showError(''); render(); return true; }
      }
      return false;
    }
    function extraCents() { var pack = packOf(state.pack), p1 = packOf(1).price; return state.pack > 1 ? Math.round((pack.price - p1) / (state.pack - 1)) : 0; }
    // Price of one dress in the chosen pack, as the pack rows say it (49.99 / 39.99 / 32.50): owner 14/10, the cards
    // and the details sheet show this with the single price struck, never "$79.99 sold apart" alone.
    function perOf(n) { return Math.floor(packOf(n).price / n + 0.49); }
    function perDress() { return perOf(state.pack); }
    function priceHtml() { var per = perDress(), u = unitCents(); return '<b>' + esc(money(per)) + '</b>' + (u > per ? ' <s>' + esc(money(u)) + '</s>' : ''); }

    /* ---------- fabric picker (owner 14/10): radio cards, pack rows (price, struck sold-apart price, free-shipping line)
       and every data-tpl text (hero, heading, sub, pack subs) re-filled for the picked fabric ---------- */
    function tokens() { return { one: money(packOf(1).price), each: money(perOf(2)), pair: money(packOf(2).price), quad: money(packOf(4).price), each4: money(perOf(4)), unit: money(unitCents()) }; }
    function renderFabric() {
      if (!FABS) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-fabric]'), function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-fabric') === fab); });
      var u = unitCents();
      Array.prototype.forEach.call(root.querySelectorAll('[data-pack]'), function (b) {
        var n = +b.getAttribute('data-pack'), pk = packOf(n), apart = u * n, el = b.querySelector('.ap-ps__packp'), fr = b.querySelector('[data-pack-free]');
        var h = '<b>' + esc(money(pk.price)) + '</b>' + (apart > pk.price ? '<s>' + esc(money(apart)) + '</s>' : '');
        if (el && el.innerHTML !== h) el.innerHTML = h;
        if (fr) fr.hidden = pk.ship > 0;
      });
      var tk = tokens();
      Array.prototype.forEach.call(root.querySelectorAll('[data-tpl]'), function (el) {
        var n = +el.getAttribute('data-tpl-n'), map = {};
        Object.keys(tk).forEach(function (k) { map[k] = tk[k]; });
        if (n) map.each = money(perOf(n)); // a pack row's {each} = that pack's price per dress
        var s = fill(el.getAttribute('data-tpl'), map);
        if (el.textContent !== s) el.textContent = s;
      });
    }

    /* ---------- sizes ---------- */
    function renderSizes() {
      $('[data-ps-sizes]').innerHTML = allSizes.map(function (z) {
        return '<button type="button" class="ap-ps__size" data-size="' + esc(z) + '" aria-pressed="' + (z === state.size) + '">' + esc(z) + '</button>';
      }).join('');
      $('[data-ps-size-name]').textContent = state.size;
    }

    /* ---------- packs ---------- */
    function renderPacks() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pack]'), function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-pack') === state.pack); });
    }

    /* ---------- slot row: N boxes, YOU PAY / +$x tags (none when data.slotTags === false, owner 15/10 16:06) ---------- */
    function renderSlots() {
      var p1 = packOf(1).price, extra = extraCents(), tags = data.slotTags !== false;
      $('[data-ps-slots]').innerHTML = state.slots.map(function (slot, i) {
        var tag = !tags ? '' : i === 0 ? '<span class="ap-ps__tag">' + esc(T.youPay) + ' ' + money(p1) + '</span>' : '<span class="ap-ps__tag ap-ps__tag--plus">+' + money(extra) + '</span>';
        if (!slot) {
          return '<div class="ap-ps__slot is-empty" data-slot="' + i + '"><button type="button" class="ap-ps__slotbox" data-slot-open="' + i + '" aria-label="' + esc(T.dress + ' ' + (i + 1)) + '"><span class="ap-ps__slotno">' + (i + 1) + '</span></button>' + tag + '</div>';
        }
        var p = prodOf(slot), ready = slotReady(slot);
        return '<div class="ap-ps__slot is-filled' + (ready ? '' : ' is-bad') + '" data-slot="' + i + '"><button type="button" class="ap-ps__slotbox" data-slot-open="' + i + '" aria-label="' + esc(T.dress + ' ' + (i + 1) + ': ' + p.name + ' ' + lineName(p.line) + ', ' + T.size + ' ' + sizeOf(slot)) + '" title="' + esc(p.name) + '">' +
          '<img src="' + esc(img(p, 0, 200)) + '" alt="" width="76" height="76" decoding="async"><span class="ap-ps__slotsize">' + esc(sizeOf(slot)) + '</span></button>' + tag + '</div>';
      }).join('');
      $('[data-ps-slots-count]').textContent = pickedCount() + ' / ' + state.pack;
    }

    /* ---------- grid: the tab's dresses, PAGE cards then "Show n more" ---------- */
    var grid = $('[data-ps-grid]'), moreBtn = $('[data-ps-more]'), gridKey = '';
    function card(p) {
      var i = products.indexOf(p);
      return '<div class="ap-ps__card" data-card="' + i + '">' +
        '<div class="ap-ps__cardimg" data-details="' + i + '"><img src="' + esc(img(p, 0, 400)) + '" alt="' + esc(p.name + ' ' + lineName(p.line) + ' ' + T.dress) + '" width="200" height="250" loading="lazy" decoding="async"></div>' +
        '<div class="ap-ps__cardt"><b>' + esc(p.name) + '</b><span>' + esc(lineName(p.line)) + '</span><span class="ap-ps__cardp" data-card-price>' + priceHtml() + '</span></div>' +
        '<a class="ap-ps__details" href="' + esc(productUrl(p)) + '" data-details="' + i + '">' + esc(T.details) + '</a>' +
        '<button type="button" class="ap-ps__add" data-add="' + i + '"></button>' +
        '<div class="ap-ps__qty" data-step="' + i + '" hidden>' +
          '<button type="button" class="ap-ps__qtyb" data-step-minus="' + i + '" aria-label="' + esc(T.remove || 'Remove one') + '">−</button>' +
          '<span class="ap-ps__qtyn" data-step-n></span>' +
          '<button type="button" class="ap-ps__qtyb" data-step-plus="' + i + '" aria-label="' + esc(T.add) + '">+</button>' +
        '</div>' +
        '<span class="ap-ps__hint" data-hint hidden>' + esc(T.fullHint) + '</span>' +
      '</div>';
    }
    function renderGrid() {
      var list = listOf(state.tab), open = !!state.expanded[state.tab], shown = open ? list : list.slice(0, PAGE);
      var key = state.tab + ':' + shown.length;
      Array.prototype.forEach.call(root.querySelectorAll('[data-tab]'), function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === state.tab); });
      if (key !== gridKey) {
        gridKey = key;
        grid.innerHTML = shown.map(card).join('');
      }
      var rest = list.length - shown.length;
      moreBtn.hidden = rest <= 0;
      moreBtn.textContent = fill(T.showMore, { n: rest });
      syncCards();
    }
    function syncCards() {
      var fullSet = isFull(), ph = priceHtml();
      Array.prototype.forEach.call(grid.querySelectorAll('[data-card-price]'), function (s) { if (s.innerHTML !== ph) s.innerHTML = ph; });
      Array.prototype.forEach.call(grid.querySelectorAll('[data-add]'), function (b) {
        var n = countIn(+b.getAttribute('data-add'));
        b.textContent = fullSet ? T.full : (n ? fill(T.added, { n: n }) : T.add);
        b.classList.toggle('is-in', n > 0 && !fullSet);
        b.classList.toggle('is-full', fullSet);
        b.setAttribute('aria-disabled', fullSet ? 'true' : 'false');
        var step = b.parentNode.querySelector('[data-step]');
        if (step) {
          step.hidden = n === 0;
          b.hidden = n > 0;
          var nEl = step.querySelector('[data-step-n]');
          if (nEl) nEl.textContent = fill(T.inSet || '{n} in set', { n: n });
          var plus = step.querySelector('[data-step-plus]');
          if (plus) { plus.classList.toggle('is-off', fullSet); plus.setAttribute('aria-disabled', fullSet ? 'true' : 'false'); }
        }
      });
      detailsSyncBtn();
    }

    /* ---------- summary, button, sticky ---------- */
    function sizesLabel() {
      var zs = [];
      state.slots.forEach(function (s) { if (s && zs.indexOf(sizeOf(s)) < 0) zs.push(sizeOf(s)); });
      if (!zs.length) zs = [state.size];
      return zs.length === 1 ? T.size + ' ' + zs[0] : T.sizes + ' ' + zs.join(', ');
    }
    function renderSummary() {
      var pack = packOf(state.pack), n = state.pack, apart = n * unitCents(), off = apart - pack.price;
      $('[data-ps-sum-count]').textContent = countWord(n) + (FABS ? ' · ' + FABS[fab].name : '') + ' · ' + sizesLabel();
      $('[data-ps-sum-price]').textContent = money(pack.price);
      $('[data-ps-sum-ship]').innerHTML = pack.ship > 0 ? esc(money(pack.ship)) : '<span class="ap-ps__free">' + esc(T.free) + '</span>';
      $('[data-ps-sum-apart]').textContent = money(apart);
      $('[data-ps-sum-off]').textContent = off > 0 ? fill(T.off, { amount: money(Math.round(off / 100) * 100).replace(/([.,]00)(?!\d)/, '') }) : '';
      var picked = pickedCount(), left = n - picked, fullSet = left <= 0;
      [$('[data-ps-atc]'), $('[data-ps-sticky-btn]')].forEach(function (b, k) {
        if (!b || b.disabled) return;
        b.textContent = fullSet ? fill(T.cta, { n: n, price: k ? '' : money(pack.price) }).replace(/\s*·\s*$/, '') : fill(T.ctaMore, { k: left });
        b.classList.toggle('is-more', !fullSet);
        b.setAttribute('aria-disabled', fullSet ? 'false' : 'true');
      });
      $('[data-ps-sticky-count]').textContent = fill(T.stickyPicked, { picked: picked, n: n });
      $('[data-ps-sticky-price]').textContent = money(pack.price);
    }

    /* ---------- sheet: one slot's size, or remove it ---------- */
    var sheet = $('[data-ps-sheet]'), sheetSlot = -1;
    function renderSheet() {
      var slot = state.slots[sheetSlot];
      if (!slot) { sheetClose(); return; }
      var p = prodOf(slot), cur = sizeOf(slot);
      $('[data-ps-sheet-title]').textContent = fill(T.sheetTitle, { n: sheetSlot + 1 });
      $('[data-ps-sheet-sub]').textContent = T.sheetSub;
      $('[data-ps-sheet-img]').src = img(p, 0, 240);
      $('[data-ps-sheet-name]').textContent = p.name;
      $('[data-ps-sheet-line]').textContent = lineName(p.line) + ' · ' + T.size + ' ' + cur;
      var sizes = (p.sizes || []).slice().sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
      $('[data-ps-sheet-sizes]').innerHTML = sizes.map(function (z) {
        var v = variantOf(p, z), ok = !!(v && v.a);
        return '<button type="button" class="ap-ps__size' + (ok ? '' : ' is-out') + '" data-sheet-size="' + esc(z) + '" aria-pressed="' + (z === cur) + '"' + (ok ? '' : ' disabled title="' + esc(T.soldOut) + '"') + '>' + esc(z) + '</button>';
      }).join('');
      $('[data-ps-sheet-note]').textContent = slotReady(slot) ? fill(T.setSize, { size: state.size }) : fill(T.errSize, { n: sheetSlot + 1 });
    }
    /* AP 03/11 — one owner for the scroll lock. Before this each dialog removed html.ap-ps-lock on its own
       'close' event, and the no-<dialog> fallback (iOS < 15.4, older Android WebView / in-app browsers) fires
       no 'close' event at all: the lock stayed on and the whole page froze. Now every open/close re-derives it. */
    function apAnyOpen() {
      var ds = [sheet, details, chart, lb], i, d;
      for (i = 0; i < ds.length; i++) { d = ds[i]; if (d && (d.open || d.hasAttribute('open'))) return true; }
      return false;
    }
    function syncLock() { document.documentElement.classList[apAnyOpen() ? 'add' : 'remove']('ap-ps-lock'); }
    window.addEventListener('pageshow', syncLock);

    function sheetOpen(i) {
      if (!sheet || !state.slots[i]) return;
      sheetSlot = i;
      renderSheet();
      if (typeof sheet.showModal === 'function') { if (!sheet.open) sheet.showModal(); } else sheet.setAttribute('open', '');
      document.documentElement.classList.add('ap-ps-lock');
    }
    function sheetClose() {
      if (!sheet) return;
      if (typeof sheet.close === 'function' && sheet.open) sheet.close(); else { sheet.removeAttribute('open'); syncLock(); }
    }
    if (sheet) {
      sheet.addEventListener('close', function () { syncLock(); sheetSlot = -1; });
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet) { sheetClose(); return; }
        var t = e.target.closest('button');
        if (!t) return;
        var slot = state.slots[sheetSlot];
        if (t.hasAttribute('data-ps-sheet-close')) sheetClose();
        else if (t.hasAttribute('data-ps-sheet-remove')) { state.slots[sheetSlot] = null; fitSlots(); sheetClose(); showError(''); render(); }
        else if (t.hasAttribute('data-sheet-size') && slot && !t.disabled) {
          var z = t.getAttribute('data-sheet-size');
          slot.size = z === state.size ? null : z;
          showError('');
          renderSheet(); renderSlots(); renderSummary();
        }
      });
    }

    function render() { renderFabric(); renderSizes(); renderPacks(); renderSlots(); renderGrid(); renderSummary(); }

    /* ---------- events ---------- */
    var err = $('[data-ps-error]'), catalog = $('[data-ps-catalog]');
    function showError(msg) { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; }
    function toGrid() { if (catalog) catalog.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    /* ---------- size-chart sheet: one tab per line; opened by every [data-ps-size-guide] (top link, the dress sheet, the
       Size guide panel). Tab = the line asked for, else the first filled slot's line, else the first tab. ---------- */
    var chart = $('[data-ps-chart]'), chartSize = '';
    function chartTab(k) {
      var tabs = chart.querySelectorAll('[data-chart-tab]'), keys = Array.prototype.map.call(tabs, function (b) { return b.getAttribute('data-chart-tab'); }), cur = chartSize || state.size;
      if (keys.indexOf(k) < 0) k = keys[0];
      Array.prototype.forEach.call(tabs, function (b) { b.setAttribute('aria-selected', b.getAttribute('data-chart-tab') === k); });
      Array.prototype.forEach.call(chart.querySelectorAll('[data-chart]'), function (p) {
        p.hidden = p.getAttribute('data-chart') !== k;
        Array.prototype.forEach.call(p.querySelectorAll('tr[data-size]'), function (r) { r.classList.toggle('is-cur', r.getAttribute('data-size') === cur); });
        var sc = p.querySelector('.ap-ps__chartscroll');
        if (sc && !p.hidden) sc.scrollLeft = 0;
      });
      chartHint();
    }
    // "Swipe for more" only when the open chart really is wider than the sheet. The dress tables (5 columns) fit a 390px
    // phone, so it normally stays hidden; it is there for a line whose CSV ever grows a column.
    function chartHint() {
      Array.prototype.forEach.call(chart.querySelectorAll('[data-chart]'), function (p) {
        var sc = p.querySelector('.ap-ps__chartscroll'), h = p.querySelector('[data-ps-chart-hint]');
        if (sc && h && !p.hidden) h.hidden = !(sc.scrollWidth > sc.clientWidth + 2);
      });
    }
    // line / size: the dress whose sheet the link sits in; else the first filled slot's line and the set size
    function chartOpen(line, size) {
      if (!chart) return;
      chartSize = size || '';
      if (!line) { var f = state.slots.filter(Boolean)[0]; line = f ? prodOf(f).line : ''; }
      chartTab(line);
      if (typeof chart.showModal === 'function') { if (!chart.open) chart.showModal(); } else chart.setAttribute('open', '');
      document.documentElement.classList.add('ap-ps-lock');
    }
    function chartClose() { if (!chart) return; if (typeof chart.close === 'function' && chart.open) chart.close(); else { chart.removeAttribute('open'); syncLock(); } }
    window.addEventListener('resize', function () { if (chart && chart.open) chartHint(); });
    if (chart) {
      chart.addEventListener('close', syncLock);
      chart.addEventListener('click', function (e) {
        if (e.target === chart) { chartClose(); return; }
        var t = e.target.closest('button');
        if (!t) return;
        if (t.hasAttribute('data-ps-chart-close')) chartClose();
        else if (t.hasAttribute('data-chart-tab')) chartTab(t.getAttribute('data-chart-tab'));
      });
      root.addEventListener('click', function (e) {
        var g = e.target.closest('[data-ps-size-guide]');
        if (!g) return;
        e.preventDefault();
        if (details && details.contains(g) && products[dIdx]) { chartOpen(products[dIdx].line, dSize || state.size); return; }
        var slot = sheet && sheet.contains(g) ? state.slots[sheetSlot] : null;
        chartOpen(slot ? prodOf(slot).line : '', slot ? sizeOf(slot) : '');
      });
    }
    var hintTimer = 0;
    // size: an override for this slot (the details sheet's size row); the set size when empty / equal
    function add(idx, size) {
      if (!products[idx]) return;
      if (isFull()) return false;
      for (var i = 0; i < state.slots.length; i++) if (!state.slots[i]) { state.slots[i] = { idx: idx, size: size && size !== state.size ? size : null }; break; }
      showError('');
      render();
      // afp-ab goal: the step the dead photo was costing us. Both arms, or the goal reads as a win for b.
      try { if (window.afpAb && typeof window.afpAb.track === 'function') window.afpAb.track('add_to_set'); } catch (e) {}
      // the set size is sold out for this dress: let her pick another size right away
      if (!slotReady(state.slots[i])) sheetOpen(i);
      return true;
    }

    /* ---------- details sheet: "View details" on a card. Photos / description come from /products/<handle>.js on the
       first open (cached); until then the inline photo(s). The size row picks the size this dress is added in. ---------- */
    var details = $('[data-ps-details]'), dIdx = -1, dSize = '', dCache = {}, dHintTimer = 0;
    function detailsSyncBtn() {
      var b = details && $('[data-ps-d-add]');
      if (!b || dIdx < 0) return;
      var fullSet = isFull(), n = countIn(dIdx);
      b.textContent = fullSet ? T.full : (n ? fill(T.added, { n: n }) : T.add);
      b.classList.toggle('is-full', fullSet);
      b.setAttribute('aria-disabled', fullSet ? 'true' : 'false');
    }
    function detailsRender(keepPhotos) {
      var p = products[dIdx];
      if (!p) return;
      var cur = dSize || state.size, c = dCache[p.handle] || {}, imgs = (c.images && c.images.length ? c.images : p.images).slice(0, 6);
      $('[data-ps-d-name]').textContent = p.name;
      $('[data-ps-d-line]').textContent = lineName(p.line);
      if (!keepPhotos) {
        var strip = $('[data-ps-d-photos]');
        strip.innerHTML = imgs.map(function (u, i) {
          return '<img src="' + esc(sized(u, 480)) + '" alt="' + esc(p.name + ' ' + lineName(p.line) + ' ' + T.dress + ', photo ' + (i + 1)) + '" width="160" height="200"' + (i ? ' loading="lazy"' : '') + ' decoding="async">';
        }).join('');
        strip.scrollLeft = 0;
        photoNavSync();
      }
      $('[data-ps-d-price]').innerHTML = priceHtml();
      var d = $('[data-ps-d-desc]');
      d.textContent = c.desc || '';
      d.hidden = !c.desc;
      $('[data-ps-d-size-name]').textContent = cur;
      var sizes = (p.sizes || []).slice().sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
      $('[data-ps-d-sizes]').innerHTML = sizes.map(function (z) {
        var v = variantOf(p, z), ok = !!(v && v.a);
        return '<button type="button" class="ap-ps__size' + (ok ? '' : ' is-out') + '" data-d-size="' + esc(z) + '" aria-pressed="' + (z === cur) + '"' + (ok ? '' : ' disabled title="' + esc(T.soldOut) + '"') + '>' + esc(z) + '</button>';
      }).join('');
      var v0 = variantOf(p, cur);
      $('[data-ps-d-note]').textContent = v0 && v0.a ? fill(T.setSize, { size: state.size }) : (T.size + ' ' + cur + ' ' + T.soldOut + ' — ' + String(T.sheetSub || '').toLowerCase());
      var u = $('[data-ps-d-url]');
      if (u) u.href = productUrl(p);
      detailsSyncBtn();
    }
    /* Owner 20/10: ‹ › for the photo strip (mouse users cannot swipe it); each shows only while photos lie that way. */
    function photoNavSync() {
      var s = details && $('[data-ps-d-photos]'), pv = details && $('[data-ps-d-prev]'), nx = details && $('[data-ps-d-next]');
      if (!s || !pv || !nx) return;
      var max = s.scrollWidth - s.clientWidth;
      pv.hidden = !(max > 4 && s.scrollLeft > 4);
      nx.hidden = !(max > 4 && s.scrollLeft < max - 4);
    }
    function photoStep(dir) {
      var s = $('[data-ps-d-photos]'), im = s && s.querySelector('img');
      if (!im) return;
      s.scrollBy({ left: dir * (im.getBoundingClientRect().width + 8), behavior: 'smooth' });
    }
    function detailsFetch(p) {
      if (dCache[p.handle] || !window.fetch) return;
      dCache[p.handle] = { images: null, desc: '' };
      fetch(productUrl(p) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (!j) return;
        var desc = '';
        try {
          var doc = new DOMParser().parseFromString(String(j.description || ''), 'text/html');
          var para = Array.prototype.filter.call(doc.querySelectorAll('p'), function (el) { return el.textContent.trim().length > 20; })[0];
          desc = (para ? para.textContent : doc.body.textContent || '').replace(/\s+/g, ' ').trim();
          if (desc.length > 320) desc = desc.slice(0, 300).replace(/\s+\S*$/, '') + '…';
        } catch (e) { /* no description */ }
        dCache[p.handle] = { images: (j.images || []).slice(0, 6), desc: desc };
        if (details.open && products[dIdx] === p) detailsRender();
      }).catch(function () { delete dCache[p.handle]; });
    }
    function detailsOpen(i) {
      if (!details || !products[i]) return;
      dIdx = i;
      dSize = '';
      detailsRender();
      $('[data-ps-d-hint]').hidden = true;
      if (typeof details.showModal === 'function') { if (!details.open) details.showModal(); } else details.setAttribute('open', '');
      details.querySelector('.ap-ps__sheetbody').scrollTop = 0;
      document.documentElement.classList.add('ap-ps-lock');
      photoNavSync();  // the strip has a width only once the sheet is open
      detailsFetch(products[i]);
    }
    function detailsClose() { if (!details) return; if (typeof details.close === 'function' && details.open) details.close(); else { details.removeAttribute('open'); syncLock(); } }
    if (details) {
      var dStrip = $('[data-ps-d-photos]');
      if (dStrip) dStrip.addEventListener('scroll', photoNavSync, { passive: true });
      window.addEventListener('resize', function () { if (details.open) photoNavSync(); });
      details.addEventListener('close', function () { syncLock(); dIdx = -1; dSize = ''; });
      details.addEventListener('click', function (e) {
        if (e.target === details) { detailsClose(); return; }
        var t = e.target.closest('button');
        if (!t) return;
        if (t.hasAttribute('data-ps-d-close')) detailsClose();
        else if (t.hasAttribute('data-ps-d-prev')) photoStep(-1);
        else if (t.hasAttribute('data-ps-d-next')) photoStep(1);
        else if (t.hasAttribute('data-d-size') && !t.disabled) { dSize = t.getAttribute('data-d-size'); if (dSize === state.size) dSize = ''; detailsRender(true); }
        else if (t.hasAttribute('data-ps-d-add')) {
          if (isFull()) {
            var h = $('[data-ps-d-hint]');
            h.hidden = false; clearTimeout(dHintTimer); dHintTimer = setTimeout(function () { h.hidden = true; }, 2500);
            return;
          }
          var i = dIdx, z = dSize;
          detailsClose();
          add(i, z);
        }
      });
      root.addEventListener('click', function (e) {
        var a = e.target.closest('[data-details]');
        if (!a || !root.contains(a)) return;
        e.preventDefault();
        detailsOpen(+a.getAttribute('data-details'));
      });
    }

    /* ---------- photo reviews (owner 15/10): a tap on a review photo opens it larger (dialog [data-ps-lb], rendered
       only when a review block has a photo; absent on the 4-line page) ---------- */
    var lb = $('[data-ps-lb]');
    function lbClose() { if (typeof lb.close === 'function' && lb.open) lb.close(); else { lb.removeAttribute('open'); syncLock(); } }
    if (lb) {
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ps-rv-photo]');
        if (!b || !root.contains(b)) return;
        e.preventDefault();
        var im = lb.querySelector('[data-ps-lb-img]'), thumb = b.querySelector('img');
        im.src = b.getAttribute('data-big') || (thumb && thumb.src) || '';
        im.alt = thumb ? thumb.alt : '';
        $('[data-ps-lb-cap]').textContent = b.getAttribute('data-cap') || '';
        $('[data-ps-lb-sub]').textContent = b.getAttribute('data-sub') || '';
        if (typeof lb.showModal === 'function') { if (!lb.open) lb.showModal(); } else lb.setAttribute('open', '');
        document.documentElement.classList.add('ap-ps-lock');
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-ps-lb-close]')) lbClose(); });
      lb.addEventListener('close', syncLock);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t) || (sheet && sheet.contains(t)) || (chart && chart.contains(t)) || (details && details.contains(t))) return;
      if (t.hasAttribute('data-size')) {
        state.size = t.getAttribute('data-size');
        state.slots.forEach(function (s) { if (s && s.size === state.size) s.size = null; });
        showError('');
        renderSizes(); renderSlots(); renderSummary();
      } else if (t.hasAttribute('data-pack')) {
        state.pack = packOf(+t.getAttribute('data-pack')).n;
        fitSlots();
        showError('');
        render();
      } else if (t.hasAttribute('data-fabric')) {
        // fabric: the picks stay; prices, size availability and the variants added follow the new fabric
        var fi = +t.getAttribute('data-fabric');
        if (FABS && FABS[fi] && fi !== fab) { fab = fi; showError(''); render(); }
      } else if (t.hasAttribute('data-tab')) {
        state.tab = t.getAttribute('data-tab');
        renderGrid();
        // design tabs (longer labels, the row scrolls sideways at 390): bring the tapped tab fully into view
        if (DESIGNS[state.tab] || (state.tab === 'all' && Object.keys(DESIGNS).length)) {
          var row = t.parentNode, rr = row.getBoundingClientRect(), tr = t.getBoundingClientRect();
          if (tr.right > rr.right) row.scrollLeft += tr.right - rr.right + 24;
          else if (tr.left < rr.left) row.scrollLeft -= rr.left - tr.left + 24;
        }
      } else if (t.hasAttribute('data-mix')) {
        // "Mix them" tile: open that line's tab and go to the grid
        state.tab = byLine[t.getAttribute('data-mix')] ? t.getAttribute('data-mix') : 'all';
        renderGrid();
        toGrid();
      } else if (t.hasAttribute('data-ps-more')) {
        state.expanded[state.tab] = true;
        renderGrid();
      } else if (t.hasAttribute('data-step-minus')) {
        removeOne(+t.getAttribute('data-step-minus'));
      } else if (t.hasAttribute('data-step-plus')) {
        add(+t.getAttribute('data-step-plus'));
      } else if (t.hasAttribute('data-add')) {
        if (add(+t.getAttribute('data-add')) === false) {
          var h = t.parentNode.querySelector('[data-hint]');
          Array.prototype.forEach.call(grid.querySelectorAll('[data-hint]'), function (x) { x.hidden = true; });
          if (h) { h.hidden = false; clearTimeout(hintTimer); hintTimer = setTimeout(function () { h.hidden = true; }, 2500); }
        }
      } else if (t.hasAttribute('data-slot-open')) {
        var si = +t.getAttribute('data-slot-open');
        if (state.slots[si]) sheetOpen(si); else toGrid();
      } else if (t.hasAttribute('data-ps-sticky-btn')) {
        if (t.classList.contains('is-more')) toGrid(); else $('[data-ps-atc]').click();
      }
    });

    /* ---------- add to cart: N lines, qty 1 each, with the _pick / _pick_n properties ---------- */
    function addLines(lines, btn) {
      var label = btn.textContent, sb = $('[data-ps-sticky-btn]'), sbLabel = sb ? sb.textContent : '';
      btn.disabled = true;
      btn.textContent = T.busy;
      if (sb) { sb.disabled = true; sb.textContent = T.busy; }
      showError('');
      var ids = lines.map(function (l) { return l.id; });
      function reset() { btn.disabled = false; btn.textContent = label; if (sb) { sb.disabled = false; sb.textContent = sbLabel; } }
      function fail(msg) { reset(); showError(msg || T.errCart); }
      var props = {};
      props[data.prop || '_pick'] = 'set';
      props[data.propN || '_pick_n'] = String(state.pack);

      /* TRACKING (29/10/2026) — the add MUST go through the page's own window.fetch to /cart/add.js.
         Shopify instruments the cart by patching window.fetch on the TOP document, so that route is
         the only one that emits product_added_to_cart, and with it GA4 add_to_cart, Meta AddToCart
         and Elevar. Measured on live (qa-storefront/qa-pick-track-probe*.js):
           Shopify.actions.updateCart  -> cart changes, NO beacon        (what this used to do)
           cleanFetch (about:blank)    -> cart changes, NO beacon        (escapes the window.fetch patch)
           window.fetch /cart/add.js   -> cart changes, ALL THREE fire   <- this
         That is why every pick was invisible in ATC and why ATC→purchase on picker surfaces could
         not be read at all. Do not route this back through cleanFetch or Shopify.actions. */
      var ADD_OPTS = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: 1, properties: props }; }) }),
      };
      function parseAdd(r) {
        return r.text().then(function (txt) {
          var j = null;
          try { j = JSON.parse(txt); } catch (e2) { /* bot-check HTML */ }
          if (r.ok && j) return j;
          throw { status: r.status, json: j };
        });
      }
      function toCartPage() { window.location.href = data.cartUrl || '/cart'; }
      function landed(cart) {
        return (cart.items || []).some(function (i) { return ids.indexOf(i.variant_id) > -1 || ids.indexOf(i.id) > -1; });
      }

      /* The drawer is rendered at page load, so after a raw /cart/add.js it still shows the old cart.
         Re-setting the first line to the quantity it already has is a no-op for the cart but makes the
         theme resync and the drawer paint the new lines. Verified safe in qa-pick-track-probe5.js:
         the `_pick` properties and the pack price both survive it (79.99 of 159.98 before and after) —
         unlike /cart/change.js, which drops properties unless they are re-sent (see ap-slot-cart.js). */
      function refreshDrawerThenOpen() {
        var act = window.Shopify && window.Shopify.actions;
        if (!act || typeof act.updateCart !== 'function' || !document.querySelector('theme-drawer#cart-drawer')) { toCartPage(); return; }
        window.fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var it = (cart.items || [])[0];
          if (!it) { toCartPage(); return; }
          return act.updateCart({ lines: [{ id: it.key, quantity: it.quantity }] }).then(function () {
            reset();
            if (typeof act.openCart === 'function') act.openCart();
          });
        }).catch(toCartPage);
      }

      window.fetch('/cart/add.js', ADD_OPTS).then(parseAdd).then(refreshDrawerThenOpen).catch(function (e1) {
        /* Something sat on window.fetch (Kaching has before) or a bot-check answered with HTML.
           Check the cart first so a request that actually landed is never added a second time,
           then retry from the clean iframe — untracked, but a sale beats a beacon. */
        window.fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (landed(cart)) { refreshDrawerThenOpen(); return; }
          cleanFetch('/cart/add.js', ADD_OPTS).then(parseAdd).then(toCartPage).catch(function (e2) {
            fail((e2 && e2.json && e2.json.description) || (e1 && e1.json && e1.json.description));
          });
        }).catch(function () {
          cleanFetch('/cart/add.js', ADD_OPTS).then(parseAdd).then(toCartPage).catch(function (e2) {
            fail((e2 && e2.json && e2.json.description) || (e1 && e1.json && e1.json.description));
          });
        });
      });
    }

    var atc = $('[data-ps-atc]');
    atc.addEventListener('click', function () {
      if (atc.disabled) return;
      if (!isFull()) { toGrid(); return; }
      var lines = [], missing = -1;
      state.slots.forEach(function (slot, i) {
        var v = slot && slotVariant(slot);
        if (!v || !v.a) { if (missing < 0) missing = i; return; }
        lines.push({ id: v.id });
      });
      if (missing > -1) {
        var box = root.querySelector('[data-slot="' + missing + '"]');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showError(fill(T.errSize, { n: missing + 1 }));
        sheetOpen(missing);
        return;
      }
      addLines(lines, atc);
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-ap-ps]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
